var RequestService = /** @class */ (function () {
    function RequestService() {
    }
    RequestService.prototype.query = function (e) {
        if (e === void 0) { e = {}; }
        return this.params(e);
    };
    RequestService.prototype.params = function (e) {
        if (e === void 0) { e = {}; }
        return (e.parameter ? e.parameter : {});
    };
    RequestService.prototype.body = function (e) {
        if (e === void 0) { e = {}; }
        var body = {};
        try {
            body = JSON.parse((e.postData && e.postData.contents) ? e.postData.contents : '{}');
        }
        catch (error) {
            /* */
        }
        return body;
    };
    return RequestService;
}());
export { RequestService };
